import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function SectionFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于樱花漫画的常见问题，快速了解我们的服务与功能
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-heading text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200/60 text-foreground-500 transition-transform duration-200"
                  style={{ transform: openIndex === idx ? 'rotate(45deg)' : 'rotate(0deg)' }}
                >
                  <i className="ri-add-line text-lg"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}